import __cloneDeep from 'lodash/cloneDeep';
import __get from 'lodash/get';

export const getActivePackage = state => state.activePackage;
export const getLeaveIntention = state => state.leaveIntention;
export const getContactIntention = state => state.contactIntention;
export const getModule = state => name => state.activePackage[name];
export const getModuleComponents = state => name => state.activePackage[name].components;
export const getModuleExtra = state => name => state.activePackage[name].extra;
export const getModuleChildren = state => name => state.activePackage[name].children;
export const getModuleConfig = state => name => state.activePackage[name].config;
export const getByPath = state => path => __cloneDeep(__get(state.activePackage, path));
export const getStatus = state => state.status;
export const getHasScroll = state => state.hasScroll;
export const getId = state => state.id;
export const getVersion = state => state.version;
export const getExternal = state => state.external;
export const getPackage = state => state.package;
export const getPrePackage = state => state.prePackage;
export const getTrackingPackage = state => state.trackingPackage;
export const getAvailableNumbers = state => state.availableNumbers;
export const getSettingsName = state => state.settingsName;

export const getSimulationType = (state, getters, rootState, rootGetters) => {
  const config = rootGetters['packages/getActivePackageConfig'];

  if (!config || !config.simulationType) {
    return null;
  }

  return config.simulationType;
};
export const getFrameVisibility = state => state.isFrameVisible;
export const getFrameUrl = state => state.frameUrl;
export const getAuth = state => state.authed;
export const getAuthToken = state => state.authToken;
export const getSalesGateway = state => state.salesGateway;
export const getMode = state => state.mode;
export const getReferral = state => state.referral;
export const getEditable = state => state.editable;
export const getBundled = state => state.isBundle;
export const getPortableInfo = state => state.isInfoVisible;

export default {
  getActivePackage,
  getLeaveIntention,
  getContactIntention,
  getByPath,
  getModule,
  getModuleComponents,
  getModuleExtra,
  getModuleChildren,
  getModuleConfig,
  getStatus,
  getHasScroll,
  getId,
  getVersion,
  getExternal,
  getPackage,
  getAvailableNumbers,
  getPrePackage,
  getTrackingPackage,
  getSettingsName,
  getSimulationType,
  getFrameVisibility,
  getFrameUrl,
  getAuth,
  getAuthToken,
  getSalesGateway,
  getMode,
  getReferral,
  getEditable,
  getBundled,
  getPortableInfo
};



// WEBPACK FOOTER //
// ./src/store/modules/simulation/getters.js